// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GuarantorCommunication,
    ObjectNoResponse,
    ProviderGuarantor,
    ProviderGuarantorSortType,
    SupportCreateGuarantorPayload,
    SupportDocument,
    SupportGenerateGuarantorBillPayload,
    SupportGuarantor,
    SupportGuarantorSortType,
    SupportReplaceGuarantorPayload,
    SupportShortUrl,
    SupportUpdateGuarantorPayload,
    TemporaryDocumentUrl,
    SupportCreateGuarantorPayloadToJSON,
    SupportGenerateGuarantorBillPayloadToJSON,
    SupportReplaceGuarantorPayloadToJSON,
    SupportUpdateGuarantorPayloadToJSON,
    GuarantorCommunicationFromJSON,
    ObjectNoResponseFromJSON,
    ProviderGuarantorFromJSON,
    SupportDocumentFromJSON,
    SupportGuarantorFromJSON,
    SupportShortUrlFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface CreateSupportGuarantorRequest {
    supportCreateGuarantorPayload: SupportCreateGuarantorPayload;
}

export interface DisableSupportGuarantorRequest {
    id: string;
}

export interface GenerateSupportGuarantorBillDocumentRequest {
    id: string;
    supportGenerateGuarantorBillPayload: SupportGenerateGuarantorBillPayload;
}

export interface GetGuarantorCheckoutUrlRequest {
    id: string;
}

export interface GetProviderGuarantorRequest {
    id: string;
}

export interface GetSupportGuarantorRequest {
    id: string;
}

export interface ListProviderGuarantorsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderGuarantorsOrderEnum>;
    filterActive?: string;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterCreated?: Array<string>;
    filterFirstLast?: Array<string>;
    filterEmail?: Array<string>;
    sort?: Array<ProviderGuarantorSortType>;
}

export interface ListSupportGuarantorCommunicationsRequest {
    id: string;
}

export interface ListSupportGuarantorsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportGuarantorsOrderEnum>;
    filterStarred?: string;
    filterActive?: string;
    filterTag?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterCreated?: Array<string>;
    filterFirstLast?: Array<string>;
    filterClaimWithCollectionStatusType?: Array<string>;
    filterEmail?: Array<string>;
    filterClaimType?: ListSupportGuarantorsFilterClaimTypeEnum;
    sort?: Array<SupportGuarantorSortType>;
}

export interface ReplaceSupportGuarantorRequest {
    supportReplaceGuarantorPayload: SupportReplaceGuarantorPayload;
}

export interface UpdateSupportGuarantorRequest {
    id: string;
    supportUpdateGuarantorPayload: SupportUpdateGuarantorPayload;
}

export interface ViewSupportGuarantorBillDocumentRequest {
    id: string;
}

/**
 * no description
 */
export class GuarantorApi extends runtime.BaseAPI {

    /**
     * Create a guarantor
     * Create a guarantor
     */
    async createSupportGuarantorRaw(requestParameters: CreateSupportGuarantorRequest): Promise<runtime.ApiResponse<SupportGuarantor>> {
        if (requestParameters['supportCreateGuarantorPayload'] === null || requestParameters['supportCreateGuarantorPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateGuarantorPayload','Required parameter requestParameters.supportCreateGuarantorPayload was null or undefined when calling createSupportGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateGuarantorPayloadToJSON(requestParameters['supportCreateGuarantorPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGuarantorFromJSON(jsonValue));
    }

    /**
     * Create a guarantor
     * Create a guarantor
     */
    async createSupportGuarantor(requestParameters: CreateSupportGuarantorRequest): Promise<SupportGuarantor> {
        const response = await this.createSupportGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a guarantor
     * Disable a guarantor
     */
    async disableSupportGuarantorRaw(requestParameters: DisableSupportGuarantorRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a guarantor
     * Disable a guarantor
     */
    async disableSupportGuarantor(requestParameters: DisableSupportGuarantorRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate a new guarantor bill
     * Generate a new guarantor bill
     */
    async generateSupportGuarantorBillDocumentRaw(requestParameters: GenerateSupportGuarantorBillDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateSupportGuarantorBillDocument.');
        }

        if (requestParameters['supportGenerateGuarantorBillPayload'] === null || requestParameters['supportGenerateGuarantorBillPayload'] === undefined) {
            throw new runtime.RequiredError('supportGenerateGuarantorBillPayload','Required parameter requestParameters.supportGenerateGuarantorBillPayload was null or undefined when calling generateSupportGuarantorBillDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}/generate_bill`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGenerateGuarantorBillPayloadToJSON(requestParameters['supportGenerateGuarantorBillPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Generate a new guarantor bill
     * Generate a new guarantor bill
     */
    async generateSupportGuarantorBillDocument(requestParameters: GenerateSupportGuarantorBillDocumentRequest): Promise<SupportDocument> {
        const response = await this.generateSupportGuarantorBillDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get customer portal url for guarantor
     * Get customer portal url for guarantor
     */
    async getGuarantorCheckoutUrlRaw(requestParameters: GetGuarantorCheckoutUrlRequest): Promise<runtime.ApiResponse<SupportShortUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getGuarantorCheckoutUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:guarantor"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}/customer_portal_url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportShortUrlFromJSON(jsonValue));
    }

    /**
     * Get customer portal url for guarantor
     * Get customer portal url for guarantor
     */
    async getGuarantorCheckoutUrl(requestParameters: GetGuarantorCheckoutUrlRequest): Promise<SupportShortUrl> {
        const response = await this.getGuarantorCheckoutUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a guarantor
     * Get a guarantor
     */
    async getProviderGuarantorRaw(requestParameters: GetProviderGuarantorRequest): Promise<runtime.ApiResponse<ProviderGuarantor>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/guarantor/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderGuarantorFromJSON(jsonValue));
    }

    /**
     * Gets a guarantor
     * Get a guarantor
     */
    async getProviderGuarantor(requestParameters: GetProviderGuarantorRequest): Promise<ProviderGuarantor> {
        const response = await this.getProviderGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a guarantor
     * Get a guarantor
     */
    async getSupportGuarantorRaw(requestParameters: GetSupportGuarantorRequest): Promise<runtime.ApiResponse<SupportGuarantor>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGuarantorFromJSON(jsonValue));
    }

    /**
     * Gets a guarantor
     * Get a guarantor
     */
    async getSupportGuarantor(requestParameters: GetSupportGuarantorRequest): Promise<SupportGuarantor> {
        const response = await this.getSupportGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of guarantors
     * Get a list of guarantors
     */
    async listProviderGuarantorsRaw(requestParameters: ListProviderGuarantorsRequest): Promise<runtime.ApiResponse<Array<ProviderGuarantor>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/guarantor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderGuarantorFromJSON));
    }

    /**
     * Gets a list of guarantors
     * Get a list of guarantors
     */
    async listProviderGuarantors(requestParameters: ListProviderGuarantorsRequest): Promise<Array<ProviderGuarantor>> {
        const response = await this.listProviderGuarantorsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of guarantor communications
     * Get a list of guarantor communications
     */
    async listSupportGuarantorCommunicationsRaw(requestParameters: ListSupportGuarantorCommunicationsRequest): Promise<runtime.ApiResponse<Array<GuarantorCommunication>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listSupportGuarantorCommunications.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}/communication`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GuarantorCommunicationFromJSON));
    }

    /**
     * Gets a list of guarantor communications
     * Get a list of guarantor communications
     */
    async listSupportGuarantorCommunications(requestParameters: ListSupportGuarantorCommunicationsRequest): Promise<Array<GuarantorCommunication>> {
        const response = await this.listSupportGuarantorCommunicationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of guarantors
     * Get a list of guarantors
     */
    async listSupportGuarantorsRaw(requestParameters: ListSupportGuarantorsRequest): Promise<runtime.ApiResponse<Array<SupportGuarantor>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterClaimWithCollectionStatusType) {
            queryParameters['filterClaimWithCollectionStatusType'] = requestParameters.filterClaimWithCollectionStatusType;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportGuarantorFromJSON));
    }

    /**
     * Gets a list of guarantors
     * Get a list of guarantors
     */
    async listSupportGuarantors(requestParameters: ListSupportGuarantorsRequest): Promise<Array<SupportGuarantor>> {
        const response = await this.listSupportGuarantorsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a guarantor
     * Replace a guarantor
     */
    async replaceSupportGuarantorRaw(requestParameters: ReplaceSupportGuarantorRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceGuarantorPayload'] === null || requestParameters['supportReplaceGuarantorPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceGuarantorPayload','Required parameter requestParameters.supportReplaceGuarantorPayload was null or undefined when calling replaceSupportGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:guarantor", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceGuarantorPayloadToJSON(requestParameters['supportReplaceGuarantorPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a guarantor
     * Replace a guarantor
     */
    async replaceSupportGuarantor(requestParameters: ReplaceSupportGuarantorRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a guarantor
     * Update a guarantor
     */
    async updateSupportGuarantorRaw(requestParameters: UpdateSupportGuarantorRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportGuarantor.');
        }

        if (requestParameters['supportUpdateGuarantorPayload'] === null || requestParameters['supportUpdateGuarantorPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateGuarantorPayload','Required parameter requestParameters.supportUpdateGuarantorPayload was null or undefined when calling updateSupportGuarantor.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateGuarantorPayloadToJSON(requestParameters['supportUpdateGuarantorPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a guarantor
     * Update a guarantor
     */
    async updateSupportGuarantor(requestParameters: UpdateSupportGuarantorRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportGuarantorRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportGuarantorBillDocumentRaw(requestParameters: ViewSupportGuarantorBillDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportGuarantorBillDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:guarantor", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/guarantor/{id}/view_bill`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportGuarantorBillDocument(requestParameters: ViewSupportGuarantorBillDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportGuarantorBillDocumentRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderGuarantorsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportGuarantorsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportGuarantorsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
